// B3: on a grown-up's own phone the session lasts 180 days, so a child who picks it up could walk
// straight into the Organiser. After 10 minutes away from the grown-up screens, opening one asks
// for the PIN again. On a child's phone (parent mode) the PIN was just typed and the 30-minute
// handback applies instead, so this doesn't.
import type { Person } from '../../shared/events'

export const ORGANISER_LOCK_MS = 10 * 60_000

/** Tabs and sheets only grown-ups open. Setting the PIN asks for the old one anyway. */
const GROWN_UP_OVERLAYS = ['organiser', 'phones', 'family', 'family-delete', 'recovery', 'trips', 'new-trip', 'prizes', 'rewards', 'bonus']
const GROWN_UP_PREFIXES = ['person:', 'controls:', 'see-as:', 'admin:', 'copy-trip:']

export function isGrownUpScreen(tab: string, overlay: string | null | undefined): boolean {
  if (tab === 'organiser' || tab === 'plan') return true
  if (!overlay) return false
  return GROWN_UP_OVERLAYS.includes(overlay) || GROWN_UP_PREFIXES.some((p) => overlay.startsWith(p))
}

/** Whether this grown-up's own phone asks for the PIN before showing a grown-up screen. */
export function organiserLocked(o: { person: Person; parentMode: boolean; onGrownUpScreen: boolean; lastTouch: number | null; now: number }): boolean {
  if (o.person.kind === 'child' || !o.person.pin || o.parentMode || !o.onGrownUpScreen) return false
  return o.lastTouch === null || o.now - o.lastTouch >= ORGANISER_LOCK_MS
}
